import React, {Component} from 'react';
import {SelectInput, TextInput} from 'admin-on-rest';
import {viewStyles} from '../shared/styles-view';
import {FilterWithSubmit} from '../admin/FilterWithSubmit';

const styles = {
    filterInput: {minWidth: 400},
    fieldSmall: {display: 'inline-block', maxWidth: 200, margin: '0 1em 0 0', verticalAlign: 'top', overflow: 'hidden'}
};

class LoyaltyAccountFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: props.filterValues ? props.filterValues.filter_by : null
        };
    }

    handleModeChange = (event, index, value) => {
        const {filterValues = {}, setFilters} = this.props;

        this.setState({mode: value});

        if (typeof setFilters === 'function') {
            const next = {
                ...filterValues,
                filter_by: value,
            };
            if (value !== 'filter_loyalty_id') next.loyalty_id = undefined;
            if (value !== 'filter_email') next.loyalty_email = undefined;
            if (value !== 'filter_phone') next.loyalty_telephone = undefined;

            setFilters(next);
        }
    };

    render() {
        const {mode} = this.state;
        const {...props} = this.props;

        return (
            <FilterWithSubmit {...props} filterButton="Find Account(s)">
                {mode === 'filter_loyalty_id' && (
                    <TextInput
                        source="loyalty_id"
                        label="Search Loyalty Accounts by ID"
                        alwaysOn
                        style={viewStyles.filterLeft}
                        elStyle={styles.filterInput}
                    />
                )}

                {mode === 'filter_email' && (
                    <TextInput
                        source="loyalty_email"
                        label="Search Loyalty Accounts by Email"
                        alwaysOn
                        style={viewStyles.filterLeft}
                        elStyle={styles.filterInput}
                    />
                )}

                {mode === 'filter_phone' && (
                    <TextInput
                        source="loyalty_telephone"
                        label="Search Loyalty Accounts by Telephone"
                        alwaysOn
                        style={viewStyles.filterLeft}
                        elStyle={styles.filterInput}
                    />
                )}

                <SelectInput
                    source="filter_by"
                    label="Select by:"
                    alwaysOn
                    choices={[
                        {id: 'filter_loyalty_id', name: 'Loyalty ID'},
                        {id: 'filter_email', name: 'Email'},
                        {id: 'filter_phone', name: 'Phone'},
                    ]}
                    style={viewStyles.filterInline}
                    defaultValue={null}
                    options={{onChange: this.handleModeChange}}
                />
            </FilterWithSubmit>
        );
    }
}

export default LoyaltyAccountFilter;



// WEBPACK FOOTER //
// ./src/Fuse/components/LoyaltyAccountFilter.js